import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import useMedia from "react-use/lib/useMedia";

import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_XS } from "@/core/media";
import { Flex, Group } from "@/eworkitComponents";
import { useCodelistTranslation } from "@/hooks/Codelist";
import { TimezoneEdit } from "@/views/Settings/UserSettings/UserAccount/UserName/TimezoneEdit";

import { IUserSectionProps } from "./types";

interface ITimezoneSectionProps extends IUserSectionProps, IEditableSectionRenderProps {}

export const TimezoneSection: FC<ITimezoneSectionProps> = props => {
  const { t } = useTranslation("session");
  const tCodelist = useCodelistTranslation();

  const isVerySmallScreen = useMedia(MEDIA_SIZE_XS);

  return props.editableProps.editMode ? (
    <TimezoneEdit
      editableProps={props.editableProps}
      source={props.record}
      initialValues={{
        settings: {
          ...props.record.settings,
        },
      }}
      onUpdate={props.onUpdate}
      onCancel={props.editableProps.handleCancelClick}
    />
  ) : (
    <Flex direction="column" innerMargin="md">
      <Flex direction={isVerySmallScreen ? "column" : "row"} innerMargin="md">
        <Flex direction="column" width={{ xxs: 12, md: 4 }}>
          <Group label={t("USERS.SETTINGS.USER_ACCOUNT.TIMEZONE.TIMEZONE")} direction="column">
            <Text size="md" color="black">
              {props.record.settings.zone}
            </Text>
          </Group>
        </Flex>

        <Flex direction="column" width={{ xxs: 12, md: 4 }}>
          <Group label={t("USERS.SETTINGS.USER_ACCOUNT.TIMEZONE.TIME_FORMAT")} direction="column">
            <Text size="md" color="black">
              {tCodelist("times-formats", props.record.settings.timeFormat.code)}
            </Text>
          </Group>
        </Flex>
      </Flex>
      <Flex direction={isVerySmallScreen ? "column" : "row"} innerMargin="md">
        <Flex direction="column" width={{ xxs: 12, md: 4 }}>
          <Group label={t("USERS.SETTINGS.USER_ACCOUNT.TIMEZONE.NUMBERS_FORMAT")} direction="column">
            <Text size="md" color="black">
              {tCodelist("numbers-formats", props.record.settings.numberFormat.code)}
            </Text>
          </Group>
        </Flex>

        <Flex direction="column" width={{ xxs: 12, md: 4 }}>
          <Group label={t("USERS.SETTINGS.USER_ACCOUNT.TIMEZONE.DATE_FORMAT")} direction="column">
            <Text size="md" color="black">
              {tCodelist("dates-formats", props.record.settings.dateFormat.code)}
            </Text>
          </Group>
        </Flex>
      </Flex>
    </Flex>
  );
};
